import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import cx from 'classnames';
import {translate} from "react-i18next";

@translate(['header'],{wait:true})
class HeaderCenter extends Component {
  render() {
    const {t} = this.props;
    return (
      <nav className="header__center-holder">
        <ul>
          <li className={cx({active: this.props.pathname === '/'})}><Link to="/">{t('header:car')}</Link></li>
          <li className={cx({active: this.props.pathname === '/rides'})}><Link to="/rides">{t('header:rides')}</Link></li>
        </ul>
      </nav>
    );
  }
}

HeaderCenter.propTypes = {
  pathname: PropTypes.string,
};

export default connect(
  (state) => {
    return {
      pathname: state.routing.locationBeforeTransitions.pathname,
    };
  },
  () => ({})
)(HeaderCenter);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderCenter.js